import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";

import {
  GET_CATEGORIES_REQUEST1,
  getCategoriesSuccess1,
  getCategoriesError1,
  GET_CATEGORY_VIDEOS_REQUEST1,
  getCategoryVideosSuccess1,
  getCategoryVideosError1,
  getCategoriesRequest1,
  PATIENT_REQUEST,
  patientSuccess,
  patientError,
  GET_LNG_LAT_MAP_REQUEST,
  getLngLatMapError,
  getLngLatMapSuccess,
  GET_PLAYLIST_VIDEOS,
  getPlayListVideoError,
  getPlayListVideoSuccess,
  GET_QRCODEVISITE_REQUEST,
  getQrCodeVisiteSuccess,
  getQrCodeVisiteError,
} from "./actions";
import { Env } from "../../env";

function* patientRequest(action) {
  let response;
  console.log("second", action.subdomain);
  // action.subdomain="dfdffa.digidocteur.com"
  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/getUserIdBySubdomain`,
      {
        params: {
          subdomain: action.subdomain,
        },
      }
    );

    //Check if want redirected webapp to website client
    let res = response.data.data.wantRedirected;
    // Check if the wall want to display
    // console.log('response URL ', response)
    // console.log('RES URL ', res)
    if (
      document.location.href != `https://${action.subdomain}/videos-patients`
    ) {
      // console.log('no wall video check ', document.location.href, " != ", `https://${action.subdomain}/videos-patients`)
      if (res != "false" && res != "true" && res != "" && res != undefined) {
        console.log("Redirection to ", response.data.data.wantRedirected);
        document.location.href = response.data.data.wantRedirected;
      } else {
        console.log("no redirected");
      }
    } else {
      console.log("wall video check ");
    }
  } catch (err) {
    let error;
    if (err.response && err.response.status === 401) {
      // console.log(err.response);
      if (
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.message === "User Deactivated"
      ) {
        error = err.response.data.error.message;
      } else {
        error = "something is wrong.";
      }
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }
    yield put(patientError());
    yield put(flashMessage(error));
    return;
  }
  const authData = response.data;
  //console.log('3',authData)
  if (authData.error == 404) {
    yield put(patientError());
  } else {
    yield put(getCategoriesRequest1(authData.data));
    yield put(patientSuccess(authData.data));
  }
}

export function* watchPatientRequest() {
  yield takeLatest(PATIENT_REQUEST, patientRequest);
}

function* getCategoriesRequest2(action) {
  let response;
  // console.log(action.authData)
  try {
    //response = yield call(axios.get, `${Env.BASE_API_URL}/Categories?filter={"where":{"specialityId":"${action.authData.specialityId}"}}`);
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Categories/getCategories?specialityId=${action.authData.specialityId}&userId=${action.authData.id}`
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
    } else {
      yield put(
        getCategoriesError1("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }
  //  console.log('videos->>>',response);
  yield put(getCategoriesSuccess1(response.data));
}

export function* watchGetCategoriesForPatientRequest() {
  yield takeLatest(GET_CATEGORIES_REQUEST1, getCategoriesRequest2);
}

// GET ALL VIDEOS IN A PLAYLIST
function* getPlaylistVideos(action) {
  // console.log("action called")
  // console.log('getPlaylistVideos ACTION', action);
  if (action.playVideo && action.playVideo.id) {
    // console.log('Id account : ', action.playVideo.id)
  }
  let response;
  try {
    // HTTP REQUEST 5e2057fbb7177d3550229cb3
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/${action.playVideo.id}/Playlists?filter={"include":"videos"}`
    );
    console.log("Response ", response);
  } catch (err) {
    // Check error
    if (err.response && err.response.status === 401) {
      console.log("An error has occurred");
      yield put(logoutRequest());
    } else {
      // Other error
      console.log("Not status error, but we have problem");
      yield put(getPlayListVideoError());
    }
    // Stop function
    return;
  }
  // Send Success with data
  console.log("videos ", response.data);

  let videoWallVideos = response.data[1].videos.filter((video) => {
    // console.log(video)
    return video.autoGeneratedForVideoWall;
  });
  if (videoWallVideos.length == 0) {
    videoWallVideos = response.data.filter((video) => {
      if (video.title == "Playliste par défaut") {
        console.log("Playlist par défaut sélectionné ", video.videos);
        return video.videos;
      }
    });
    return yield put(getPlayListVideoSuccess(videoWallVideos[0].videos));
  } else {
    console.log("Playlist pas vide ", videoWallVideos);
  }
  console.log("video ", videoWallVideos);
  yield put(getPlayListVideoSuccess(videoWallVideos));
  // console.log("INSIDE SAGA", videoWallVideos);
}

// Export to sagas.js
export function* watchGetPlaylistVideos() {
  yield takeLatest(GET_PLAYLIST_VIDEOS, getPlaylistVideos);
}

// Get lng and lat on the google map
function* getLngLatMap(action) {
  if (action && action.lngLat && action.lngLat.postaladdress) {
    // console.log('Action MAP SAGA : ', action.lngLat.postaladdress);
    let response;
    const location = action.lngLat.postaladdress;
    try {
      response = yield call(
        axios.get,
        `https://maps.googleapis.com/maps/api/geocode/json?address=${location}&key=${Env.API_GOOGLE_MAP}`
      );
    } catch (err) {
      if (err.response && err.response.status === 401) {
        console.log("An error has occurred");
        yield put(logoutRequest());
      } else {
        console.log("Not status error, but we have problem");
        yield put(getLngLatMapError());
      }
      return;
    }
    // Send Success with data
    if (response.data.results.length > 0) {
      var latitude = response.data.results[0].geometry.location.lat;
      var longitude = response.data.results[0].geometry.location.lng;
      // console.log('HEY')
    } else {
      var latitude = 41.9270425;
      var longitude = 8.7354979;
      // console.log('NOP')
    }
    yield put(
      getLngLatMapSuccess({ latitude: latitude, longitude: longitude })
    );
  }
}

// Export to sagas.js
export function* watchGetLngLatMap() {
  yield takeLatest(GET_LNG_LAT_MAP_REQUEST, getLngLatMap);
}

function* getCategoryVideosRequest1(action) {
  const { categoryId, userId } = action;
  let response;
  const id = userId.replace("?", "");
  try {
    response = yield call(
      axios.get,
      //`${Env.BASE_API_URL}/Categories/${categoryId}/videos?filter={"where":{"ownerId":"${id}","isAd":false}}`);
      `${Env.BASE_API_URL}/Categories/getCategoryVideos?categoryId=${categoryId}&userId=${id}&isAd=false`
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getCategoryVideosError1(
          "Une erreur s'est produite, veuillez réessayer."
        )
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }
    return;
  }
  //console.log('hdjkashdfjkadhfjdhf',response.data );
  yield put(getCategoryVideosSuccess1(response.data));
}

export function* watchGetCategoryVideosForPatientRequest() {
  yield takeLatest(GET_CATEGORY_VIDEOS_REQUEST1, getCategoryVideosRequest1);
}

//Function for update data in bdd stats
/**
 * @param action => Object {subdomain}
 */
function* getQrcodeVisiteRequest(action) {
  console.log("ON SAGA ++ ", action);
  const subdomain = action.payload;
  let response;
  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/IncreamentNbVisite?subdomain=${subdomain}`
    );
    console.log("RESPONSE ", response);
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(flashMessage(error));
    } else {
      yield put(getQrCodeVisiteError("Somthing is wrong.", err.reponse));
    }
    return;
  }
  yield put(getQrCodeVisiteSuccess(response));
}

export default function* watchgetQrcodeVisiteRequest() {
  yield takeLatest(GET_QRCODEVISITE_REQUEST, getQrcodeVisiteRequest);
}



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/saga.js